import { primaryColor, blackColors } from 'assets/jss/material-dashboard-pro-react';
import customSelectorsStyle from './customSelectorsStyle';

const customRadioStyle = {
	...customSelectorsStyle,
	uncheckedIcon: {},
	checkedIcon: {},
	radio: {
		color: primaryColor[0] + '!important',
	},
	radioDisabled: {
		color: blackColors[6] + '!important',
	},
	radioChecked: {
		width: '22px',
		height: '22px',
		border: '2px solid ' + primaryColor[0],
		borderRadius: '50%',
		padding: '1.5px',
	},
	radioUnchecked: {
		width: '0px',
		height: '0px',
		padding: '9px',
		backgroundColor: blackColors[6],
		border: `2px solid ${blackColors[4]}`,
		borderRadius: '50%',
	},
	radioRoot: {
		padding: '9px',
		'&:hover': {
			backgroundColor: 'unset',
		},
	},
};

export default customRadioStyle;
